import { ReduxState } from 'src/store/types';

export const entityDrawerSelector = (state: ReduxState) =>
  state.ui.entityDrawer;
